import { FieldPath, FieldValues, UseFormReturn, get } from "react-hook-form"

type GetFormErrorArgs<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> = {
  name: TName
  form: UseFormReturn<TFieldValues>
}

export function getFormError<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>(args: GetFormErrorArgs<TFieldValues, TName>) {
  return get(args.form.formState.errors, `${args.name}.message`)
}

export function getFormSuccess<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>(args: GetFormErrorArgs<TFieldValues, TName>) {
  return get(args.form.formState.touchedFields, args.name) && !get(args.form.formState.errors, args.name)
}

export function parseNumber(stringValue: string) {
  const value = Number.parseInt(stringValue)
  return Number.isNaN(value) ? undefined : value
}
